/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type CustomFolderColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const CustomFolderColorable = ({ color, ...props }: CustomFolderColorableProps) => {
  const gradientId = useMemo(
    () => `customfolder_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('CustomFolder', color);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" fill="none" {...props}>
      <circle cx={22.5} cy={22.5} r={22.5} fill={`url(#${gradientId})`} />
      <path
        fill="#fff"
        d="M14.5 16a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h16a1.5 1.5 0 0 0
        1.5-1.5v-8a1.5 1.5 0 0 0-1.5-1.5h-7.172a1.5 1.5 0 0 1-1.06-.44l-1.06-1.06a1.5
        1.5 0 0 0-1.061-.44H14.5Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.3}
        d="M14.5 16a1.5 1.5 0 0 0-1.5 1.5v2h19v-.5a1.5 1.5 0 0 0-1.5-1.5h-7.172a1.5
        1.5 0 0 1-1.06-.44l-1.06-1.06a1.5 1.5 0 0 0-1.061-.44H14.5Z"
      />
      <defs>
        <linearGradient id={gradientId} x1={0} x2={45} y1={0} y2={45} gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset={1} stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CustomFolderColorable;
